var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
/** Vite 构建（import.meta.env）；CRA 无此项时为空，避免误用 */
export function readViteEnv(key) {
    try {
        var env = import.meta.env;
        var v = env === null || env === void 0 ? void 0 : env[key];
        return typeof v === "string" ? v.trim() : "";
    }
    catch (_a) {
        return "";
    }
}
export function getMsOrgApiBaseUrl(options) {
    var _a, _b, _c;
    var fromOpts = (_a = options === null || options === void 0 ? void 0 : options.msOrgApiBaseUrl) === null || _a === void 0 ? void 0 : _a.trim();
    var fromEnv = (typeof process !== "undefined" && ((_c = (_b = process.env) === null || _b === void 0 ? void 0 : _b.REACT_APP_MSORG_API_BASE_URL) === null || _c === void 0 ? void 0 : _c.trim())) ||
        readViteEnv("VITE_MSORG_API_BASE_URL") ||
        "";
    var v = fromOpts || fromEnv;
    if (v)
        return v.replace(/\/$/, "");
    return "/api/msorg";
}
export function resolveApplicationId(options) {
    var _a, _b, _c;
    var v = ((_a = options === null || options === void 0 ? void 0 : options.applicationId) === null || _a === void 0 ? void 0 : _a.trim()) ||
        (typeof process !== "undefined" && ((_c = (_b = process.env) === null || _b === void 0 ? void 0 : _b.REACT_APP_MSORG_APPLICATION_ID) === null || _c === void 0 ? void 0 : _c.trim())) ||
        readViteEnv("VITE_MSORG_APPLICATION_ID") ||
        "";
    return v;
}
function getSessionVerifyTimeoutMs(options) {
    var _a, _b;
    var fromOpts = options === null || options === void 0 ? void 0 : options.sessionVerifyTimeoutMs;
    if (typeof fromOpts === "number" && Number.isFinite(fromOpts) && fromOpts > 0) {
        return Math.floor(fromOpts);
    }
    var envRaw = (typeof process !== "undefined" && ((_b = (_a = process.env) === null || _a === void 0 ? void 0 : _a.REACT_APP_MSORG_SESSION_VERIFY_TIMEOUT_MS) === null || _b === void 0 ? void 0 : _b.trim())) ||
        readViteEnv("VITE_MSORG_SESSION_VERIFY_TIMEOUT_MS");
    var fromEnv = envRaw ? Number(envRaw) : 0;
    if (Number.isFinite(fromEnv) && fromEnv > 0) {
        return Math.floor(fromEnv);
    }
    /** 与 msCrm `msOrgCentralSessionProbe.PROBE_TIMEOUT_MS` 对齐 */
    return 12000;
}
/** sessionStorage 中短时跳过重复 GET /auth/me 的标记（同标签页刷新仍保留，显著降低「每次刷新 2～3 秒」体感） */
var SESSION_VERIFY_CACHE_KEY = "msorg_verify_ok_v1";
function tokenFingerprint(token) {
    var h = 2166136261;
    for (var i = 0; i < token.length; i++) {
        h ^= token.charCodeAt(i);
        h = Math.imul(h, 16777619);
    }
    return "".concat(h >>> 0, ":").concat(token.length);
}
function readMsOrgVerifyCacheTtlMs() {
    var _a, _b;
    var raw = (typeof process !== "undefined" && ((_b = (_a = process.env) === null || _a === void 0 ? void 0 : _a.REACT_APP_MSORG_SESSION_VERIFY_CACHE_MS) === null || _b === void 0 ? void 0 : _b.trim())) ||
        readViteEnv("VITE_MSORG_SESSION_VERIFY_CACHE_MS");
    var n = raw ? Number(raw) : 0;
    if (Number.isFinite(n) && n > 0) {
        return Math.floor(n);
    }
    return 90000;
}
function tryReadSessionVerifyCache(token) {
    try {
        if (typeof sessionStorage === "undefined")
            return false;
        var raw = sessionStorage.getItem(SESSION_VERIFY_CACHE_KEY);
        if (!raw)
            return false;
        var parsed = JSON.parse(raw);
        if (typeof parsed.fp !== "string" || typeof parsed.ts !== "number")
            return false;
        if (parsed.fp !== tokenFingerprint(token))
            return false;
        if (Date.now() - parsed.ts > readMsOrgVerifyCacheTtlMs())
            return false;
        return true;
    }
    catch (_a) {
        return false;
    }
}
function writeSessionVerifyCache(token) {
    try {
        if (typeof sessionStorage === "undefined")
            return;
        sessionStorage.setItem(SESSION_VERIFY_CACHE_KEY, JSON.stringify({ fp: tokenFingerprint(token), ts: Date.now() }));
    }
    catch (_a) {
        /* 企微 WebView 可能禁用 storage */
    }
}
function clearSessionVerifyCache() {
    try {
        if (typeof sessionStorage === "undefined")
            return;
        sessionStorage.removeItem(SESSION_VERIFY_CACHE_KEY);
    }
    catch (_a) {
        /* ignore */
    }
}
/** 登出/清票时调用，避免残留「已验票」标记 */
export function clearMsOrgSessionVerifyCache() {
    clearSessionVerifyCache();
}
/** 同一 token 并发验票合并为单次请求（如 React Strict Mode 双挂载） */
var inFlightVerify = new Map();
export function wecomLogin(payload, options) {
    return __awaiter(this, void 0, Promise, function () {
        var base, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    base = getMsOrgApiBaseUrl(options);
                    return [4 /*yield*/, axios.post("".concat(base, "/auth/wecom-login"), payload, {
                            headers: { "Content-Type": "application/json" },
                            timeout: 20000,
                        })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.data];
            }
        });
    });
}
/**
 * 调 msOrg GET /auth/me。
 * - invalid：401/403 或明确失败 → 可清票后走企微 OAuth
 * - transport_error：超时/断网/5xx → **不得**自动跳转 OAuth，否则用户未经验证又换票进入
 */
function verifySessionWithMsOrgUncached(token, options) {
    var _a, _b;
    return __awaiter(this, void 0, Promise, function () {
        var base, res, e_1, st;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    base = getMsOrgApiBaseUrl(options);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.get("".concat(base, "/auth/me"), {
                            headers: { Authorization: "Bearer ".concat(token) },
                            timeout: getSessionVerifyTimeoutMs(options),
                        })];
                case 2:
                    res = _c.sent();
                    if (((_a = res.data) === null || _a === void 0 ? void 0 : _a.success) === true) {
                        writeSessionVerifyCache(token);
                        return [2 /*return*/, { kind: "ok" }];
                    }
                    clearSessionVerifyCache();
                    return [2 /*return*/, { kind: "invalid" }];
                case 3:
                    e_1 = _c.sent();
                    if (axios.isAxiosError(e_1)) {
                        st = (_b = e_1.response) === null || _b === void 0 ? void 0 : _b.status;
                        if (st === 401 || st === 403) {
                            clearSessionVerifyCache();
                            return [2 /*return*/, { kind: "invalid" }];
                        }
                        if (!e_1.response || e_1.code === "ECONNABORTED" || e_1.code === "ERR_NETWORK") {
                            return [2 /*return*/, { kind: "transport_error", message: e_1.message }];
                        }
                        if (st != null && st >= 500) {
                            return [2 /*return*/, { kind: "transport_error", message: "HTTP ".concat(st) }];
                        }
                        if (st != null && st >= 400) {
                            clearSessionVerifyCache();
                            return [2 /*return*/, { kind: "invalid" }];
                        }
                    }
                    return [2 /*return*/, {
                            kind: "transport_error",
                            message: e_1 instanceof Error ? e_1.message : String(e_1),
                        }];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function verifySessionWithMsOrg(token, options) {
    return __awaiter(this, void 0, Promise, function () {
        var t, fp, p;
        return __generator(this, function (_a) {
            t = token.trim();
            if (!t) {
                return [2 /*return*/, { kind: "invalid" }];
            }
            if (tryReadSessionVerifyCache(t)) {
                return [2 /*return*/, { kind: "ok" }];
            }
            fp = tokenFingerprint(t);
            p = inFlightVerify.get(fp);
            if (!p) {
                p = verifySessionWithMsOrgUncached(t, options).finally(function () {
                    inFlightVerify.delete(fp);
                });
                inFlightVerify.set(fp, p);
            }
            return [2 /*return*/, p];
        });
    });
}
/** 仅关心是否通过；超时/网络错误也视为 false（旧逻辑，非守卫场景慎用） */
export function verifyCurrentUser(token, options) {
    return __awaiter(this, void 0, Promise, function () {
        var r;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, verifySessionWithMsOrg(token, options)];
                case 1:
                    r = _a.sent();
                    return [2 /*return*/, r.kind === "ok"];
            }
        });
    });
}
